import { action } from "typesafe-actions";
import { IEmailHistoryLog } from "./Emails.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const FETCH_EMAIL_HISTORY_LOG_LIST_PROGRESS =
  "FETCH_EMAIL_HISTORY_LOG_LIST_PROGRESS";
export const FETCH_EMAIL_HISTORY_LOG_LIST_SUCCESS =
  "FETCH_EMAIL_HISTORY_LOG_LIST_SUCCESS";
export const FETCH_EMAIL_HISTORY_LOG_LIST_FAILED =
  "FETCH_EMAIL_HISTORY_LOG_LIST_FAILED";

export const fetchEmailsHistoryLogListProgress = () =>
  action(FETCH_EMAIL_HISTORY_LOG_LIST_PROGRESS);
export const fetchEmailsHistoryLogListSuccess = (
  list: IEmailHistoryLog[],
  totalRecords: number
) => action(FETCH_EMAIL_HISTORY_LOG_LIST_SUCCESS, { list, totalRecords });
export const fetchEmailsHistoryLogListFailed = () =>
  action(FETCH_EMAIL_HISTORY_LOG_LIST_FAILED);

export const fetchEmailsHistoryLogListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
      date: IDataTableV2DateState["dates"],
        searchValue: IDatatableV2AdvancedSearchFilter,
  status: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchEmailsHistoryLogListProgress());
      const url = "";
    

      let finalUrl = `/general/get-email-history?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;
if (searchValue.length > 0) {
        finalUrl = `/general/get-email-history?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;

        if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      }
      const res = await api.get(finalUrl);
      const data: IEmailHistoryLog[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchEmailsHistoryLogListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchEmailsHistoryLogListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


export const CLEAR_EMAILS_STATE = "CLEAR_EMAILS_STATE";
export const clearEmailsState = () => action(CLEAR_EMAILS_STATE);